
__webpack_require__.S = {};
__webpack_require__.initializeSharingData = { scopeToSharingDataMapping: { "default": [{ name: "@nackle/biw-web-router", version: "1.3.21", factory: () => (Promise.all([__webpack_require__.e("793"), __webpack_require__.e("545"), __webpack_require__.e("890"), __webpack_require__.e("619")]).then(() => (() => (__webpack_require__(86672))))), eager: 0 }, { name: "@nackle/bridge", version: "3.0.43", factory: () => (Promise.all([__webpack_require__.e("667"), __webpack_require__.e("890"), __webpack_require__.e("561")]).then(() => (() => (__webpack_require__(16054))))), eager: 0 }, { name: "@nackle/intl-tools", version: "1.4.85", factory: () => (Promise.all([__webpack_require__.e("3"), __webpack_require__.e("475"), __webpack_require__.e("641")]).then(() => (() => (__webpack_require__(88950))))), eager: 0 }, { name: "@nackle/origami-icons", version: "1.6.76", factory: () => (Promise.all([__webpack_require__.e("290"), __webpack_require__.e("902")]).then(() => (() => (__webpack_require__(95257))))), eager: 0 }, { name: "@nackle/umbrella-studio", version: "1.5.30", factory: () => (Promise.all([__webpack_require__.e("514"), __webpack_require__.e("890")]).then(() => (() => (__webpack_require__(19097))))), eager: 0 }, { name: "@nackle/umbrella", version: "2.0.45", factory: () => (Promise.all([__webpack_require__.e("827"), __webpack_require__.e("306")]).then(() => (() => (__webpack_require__(44806))))), eager: 0 }, { name: "antd", version: "5.27.1", factory: () => (Promise.all([__webpack_require__.e("111"), __webpack_require__.e("115"), __webpack_require__.e("303"), __webpack_require__.e("770")]).then(() => (() => (__webpack_require__(25246))))), eager: 0 }, { name: "react-dom", version: "18.3.1", factory: () => (Promise.all([__webpack_require__.e("396"), __webpack_require__.e("890")]).then(() => (() => (__webpack_require__(8143))))), eager: 0 }, { name: "react", version: "18.3.1", factory: () => (__webpack_require__.e("75").then(() => (() => (__webpack_require__(30758))))), eager: 0 }] }, uniqueName: "gantry-studio" };
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if (!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if (!initToken) initToken = initTokens[name] = {};
	if (initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if (initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if (!__webpack_require__.o(__webpack_require__.S, name))
		__webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function (msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = __webpack_require__.initializeSharingData.uniqueName;
	var register = function (name, version, factory, eager) {
		var versions = (scope[name] = scope[name] || {});
		var activeVersion = versions[version];
		if (
			!activeVersion ||
			(!activeVersion.loaded &&
				(!eager != !activeVersion.eager
					? eager
					: uniqueName > activeVersion.from))
		)
			versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function (id) {
		var handleError = function (err) {
			warn("Initialization of sharing external failed: " + err);
		};
		try {
			var module = __webpack_require__(id);
			if (!module) return;
			var initFn = function (module) {
				return (
					module &&
					module.init &&
					module.init(__webpack_require__.S[name], initScope)
				);
			};
			if (module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if (initResult && initResult.then)
				return promises.push(initResult["catch"](handleError));
		} catch (err) {
			handleError(err);
		}
	};
	var promises = [];
	var scopeToSharingDataMapping = __webpack_require__.initializeSharingData.scopeToSharingDataMapping;
	if (scopeToSharingDataMapping[name]) {
		scopeToSharingDataMapping[name].forEach(function (stage) {
			if (typeof stage === "object") register(stage.name, stage.version, stage.factory, stage.eager);
			else initExternal(stage)
		});
	}
	if (!promises.length) return (initPromises[name] = 1);
	return (initPromises[name] = Promise.all(promises).then(function () {
		return (initPromises[name] = 1);
	}));
};

